module.exports = __webpack_public_path__ + "vg.svg?eef14ab6f09e3eaf612af872df742845";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/vg.svg
// module id = 1431
// module chunks = 0